import { initializeApp, FirebaseApp } from 'firebase/app';
import { getFirestore, Firestore } from 'firebase/firestore';
import { firebaseConfig } from './config';

let app: FirebaseApp | null = null;
let db: Firestore | null = null;

// Validate Firebase config has all required fields
function isValidFirebaseConfig(config: any): boolean {
  if (!config) return false;
  
  const requiredFields = ['apiKey', 'authDomain', 'projectId', 'storageBucket', 'messagingSenderId', 'appId'];
  return requiredFields.every(field => config[field] && config[field].length > 0);
}

// Initialize Firebase only if config is available and valid
export function initializeFirebase() {
  if (!firebaseConfig || !isValidFirebaseConfig(firebaseConfig)) {
    console.info('ℹ️  Firebase not configured - using Supabase only');
    return null;
  }

  if (!app) {
    try {
      app = initializeApp(firebaseConfig);
      db = getFirestore(app);
      console.log('✅ Firebase initialized successfully');
    } catch (error) {
      console.error('❌ Failed to initialize Firebase:', error);
      return null;
    }
  }

  return { app, db };
}

export function getFirebaseDB(): Firestore | null {
  if (!db) {
    const initialized = initializeFirebase();
    return initialized?.db || null;
  }
  return db;
}

export function isFirebaseConfigured(): boolean {
  return !!firebaseConfig;
}